'use client';

import Link from 'next/link';
import type { ComponentProps } from 'react';
import { forwardRef, useLayoutEffect, useState } from 'react';
import { appendCampaignParamsToUrl } from '@/lib/persistCampaignParams';

/**
 * UTM / kampanya parametreleri sunucuda bilinmez; href’e doğrudan append etmek hydration
 * uyumsuzluğu üretir. İlk paint sunucu ile aynı kalır, mount sonrası query eklenir.
 */
export type CampaignLinkProps = Omit<ComponentProps<typeof Link>, 'href'> & {
  href: string;
};

export const CampaignLink = forwardRef<HTMLAnchorElement, CampaignLinkProps>(
  function CampaignLink({ href, ...rest }, ref) {
    const [resolved, setResolved] = useState(href);

    useLayoutEffect(() => {
      setResolved(appendCampaignParamsToUrl(href));
    }, [href]);

    return <Link ref={ref} href={resolved} {...rest} />;
  },
);
